<template>
  <div class="tieZi">
    <wv-group>

      <div class="form-group">
        <div class="col-sm-10" id="eie">
          <label class="labelClass">服务类型</label><em class="emClass">*</em>
          <label class="radio-inline">
            <input type="radio" name="serviceType" value="1" v-model="currObj.tieziType"> 投诉
          </label>
          <label class="radio-inline">
            <input type="radio" name="serviceType"  value="2" v-model="currObj.tieziType">建议
          </label>
          <label class="radio-inline">
            <input type="radio" name="serviceType" value="3" v-model="currObj.tieziType">咨询
          </label>
          <label class="radio-inline">
            <input type="radio" name="serviceType" value="4"v-model="currObj.tieziType">表扬
          </label>
        </div>
      </div>
      <div class="form-group" >
        <label class="labelClass">发帖人&nbsp;&nbsp;&nbsp;&nbsp;</label><em class="emClass">*</em>
        <input  type="text"  v-model="currObj.name"  disabled required  :validate-mode="{onFocus: false}" ref="nameInput"  placeholder="发帖人"/>
      </div>

      <div class="form-group" >
        <label class="labelClass">手机号码</label><em class="emClass">*</em>
        <input   v-model="currObj.phone" type="number"   required ref="phoneInput"  placeholder="手机号码"/>
      </div>

      <div class="form-group" >
        <label class="labelClass">班级/部门&nbsp;</label><em class="emClass">*</em>
        <input  type="text"  v-model="currObj.classNameOrDeparment" disabled required  :validate-mode="{onFocus: false}" ref="nameInput"  placeholder="班级/部门"/>
      </div>


      <div class="form-group" >
        <label class="labelClass">帖子标题</label><em class="emClass">*</em>
        <input  type="text"   placeholder="标题" v-model="currObj.title" required :validate-mode="{onFocus: false, onBlur: true, onChange: false}" ref="titleInput"/>
      </div>
      <!--一级菜单-->
      <label class="labelClass">服务项目</label><em class="emClass">*</em>
      <select name="serviceitemType" id="serviceitemType" class="classify"  v-on:change="indexSelect01" v-model="currObj.serviceitemType">
       <!-- <option value="一级菜单" selected>请选择</option>-->
        <option :value="item.id" v-for="(item,index) in serviceItemName1">{{item.name}}</option>
      </select>
      <!--二级菜单-->
      <select name="serviceitemId" id="serviceitemId" class="classify mt10" v-model="currObj.serviceitemId">
       <!-- <option value="二级菜单"selected>请选择</option>-->
        <option :value="k.id" v-for="(k,index) in serviceItemName2">{{k.name}}</option>
      </select>
      <div class="form-group" >
       <label class="labelClass">校区</label><em class="emClass">*</em>
       <select name="distName" id="distName" class="distName"   v-model="currObj.distName">
         <option value="昆仑校区" >昆仑校区</option>
         <option value="园湖校区" >园湖校区</option>
         <option value="相思湖校区">相思湖校区</option>
       </select>
      </div>
      <wv-textarea placeholder="发帖内容" :rows="3" v-model="currObj.content"  :max-length="200"></wv-textarea>

    </wv-group>
    <div style="margin-top: 10px;margin-left: 10px">
      <label  >上传图片(最多可上传5张图片)</label>
    </div>
    <div style="margin-top: 10px;margin-left: 10px">
      <label  ><span  class="sizeStyle" >温馨提示:</span>如不能上传图片，请点击有右上方三个圆点，选择用浏览器打开进行填写帖子上传图片</label>
    </div>
    <div style="margin-top: 10px;margin-left: 20px">

      <van-uploader
        v-model="fileList"
        multiple
        :max-count="5"
        :before-read="beforeRead"
        :after-read="upload"
        :accept="'image/*'"
      />

    </div>
    <br/>
    <wv-button type="primary"  style="width:90%;background-color: #26a2ff" @click="submitData" :disabled="isDisable">提交</wv-button>
  </div>
</template>


<script type="text/ecmascript-6">
  import { Uploader } from 'vant';
  import { getServiceItem,addTiezi, OK,HOST,getUserInfoByValidateurlPC,getUserInfoByValidateurl,casHost} from '../api/data.js'
  import Exif from 'exif-js'
  import axios from 'axios'
  import { Toast,MessageBox} from 'mint-ui';
  import Vue from 'vue'
  Vue.use(Uploader);
  export default {
    data () {
      return {
        serviceItemName1:[] ,//获取的一级数组数据
        serviceItemName2: [],//获取的二级数组数据
        serviceItemName: [],//临时保存服务项目名称
        indexNum:0,//定义一级菜单的下标
        isDisable:false,
        currObj:{
          tieziType:"1",
          serviceitemType:'请选择',//定义分类一的默认值
          serviceitemId:'请选择',
          title:'',
          content:'',
          name:localStorage.getItem("username"),
          phone:localStorage.getItem("telePhone"),
          classNameOrDeparment:localStorage.getItem("classNameOrDeparment"),
          imgList:[],
          distName:'昆仑校区',
          imagePath:''
        },
        fileList: [],
        files: {
          name: "",
          type: ""
        },
        imgUrls: [],
        urlArr: [],
        isPhoto: true,
        btnTitle: '',
        isModify: false,
        previewImg:'',
        isPreview: false,
        headerImage:'',
        picValue: null,


      }
    },
    components:{

    },
    computed:{
    },

    mounted(){
      this.isDisable = false;//开始可以点击
      this.initServiceItem();


    },

    watch: {
      imgUrls: 'toggleAddPic'
    },

    methods: {
      initServiceItem(){
        getServiceItem().then((res) => {
          if(res.status === OK) {
            let mes = res.data;
            let i = 0;
            let j = 0;
            this.serviceItemName =mes.data;
            for (i = 0;i<mes.data.length;i++) {

              if (mes.data[i].pid == 0){
                this.serviceItemName1[j] = mes.data[i]
                j++;
              }
            }

            this.indexSelect01();
          }else{
            Toast('获取服务项失败')
          }
        })
          .catch((error) => {
            console.log(error)
          });


      },
      indexSelect01(){
        let i = 0;
        let j = 0;
        let flag = false;
        this.serviceItemName2=[];
        for (i = 0;i<this.serviceItemName.length;i++) {
          if (this.serviceItemName[i].pid == this.currObj.serviceitemType){
            this.serviceItemName2[j] =this.serviceItemName[i]
            j++;
            flag = true;

          }

        }
        if(!flag){
          this.serviceItemName2=[];

        }

      },

      // 返回布尔值
      beforeRead(file) {
        if (file.type == 'image/jpeg'|| file.type == 'image/png') {
          return true;
        }else{
          Toast('请上传jpg或png格式的图片');
          return false;
        }
      },
      async  upload(file) {
        this.files.name = file.file.name; // 获取文件名
        this.files.type = file.file.type; // 获取类型
        this.picValue = file.file; // 文件流
        this.imgPreview(this.picValue);
      },
      imgPreview(file) {
        let self = this;
        let Orientation;
        //去获取拍照时的信息，解决拍出来的照片旋转问题
        Exif.getData(file, function () {
          Orientation = Exif.getTag(this, 'Orientation');
        });
        // 看支持不支持FileReader
        if (!file || !window.FileReader) return;

        if (/^image/.test(file.type)) {
          // 创建一个reader
          let reader = new FileReader();
          // 将图片2将转成 base64 格式
          reader.readAsDataURL(file);
          // 读取成功后的回调
          reader.onloadend = function () {
            let result = this.result;
            let img = new Image();
            img.src = result;
            //判断图片是否小于100K,是就直接上传，反之压缩图片
            if (this.result.length <= (100 * 1024)) {

              //self.headerImage = this.result;
              self.headerImage =self.headerImage +  "@"+ this.result;
            } else {
              img.onload = function () {
                let data = self.compress(img, Orientation);
                //self.headerImage = data;

               self.headerImage =self.headerImage+  "@"+ data

              }
            }
          }
        }
      },
      compress(img, Orientation) {
        let canvas = document.createElement("canvas");
        let ctx = canvas.getContext('2d');
        //瓦片canvas
        let tCanvas = document.createElement("canvas");
        let tctx = tCanvas.getContext("2d");
        let initSize = img.src.length;
        let width = img.width;
        let height = img.height;
        //如果图片大于四百万像素，计算压缩比并将大小压至400万以下
        let ratio;
        if ((ratio = width * height / 4000000) > 1) {
          console.log("大于400万像素")
          ratio = Math.sqrt(ratio);
          width /= ratio;
          height /= ratio;
        } else {
          ratio = 1;
        }
        canvas.width = width;
        canvas.height = height;
        //        铺底色
        ctx.fillStyle = "#fff";
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        //如果图片像素大于100万则使用瓦片绘制
        let count;
        if ((count = width * height / 1000000) > 1) {
          console.log("超过100W像素");
          count = ~~(Math.sqrt(count) + 1); //计算要分成多少块瓦片
          //            计算每块瓦片的宽和高
          let nw = ~~(width / count);
          let nh = ~~(height / count);
          tCanvas.width = nw;
          tCanvas.height = nh;
          for (let i = 0; i < count; i++) {
            for (let j = 0; j < count; j++) {
              tctx.drawImage(img, i * nw * ratio, j * nh * ratio, nw * ratio, nh * ratio, 0, 0, nw, nh);
              ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh);
            }
          }
        } else {
          ctx.drawImage(img, 0, 0, width, height);
        }
        //修复ios上传图片的时候 被旋转的问题
        if (Orientation != "" && Orientation != 1) {
          switch (Orientation) {
            case 6://需要顺时针（向左）90度旋转
              this.rotateImg(img, 'left', canvas);
              break;
            case 8://需要逆时针（向右）90度旋转
              this.rotateImg(img, 'right', canvas);
              break;
            case 3://需要180度旋转
              this.rotateImg(img, 'right', canvas);//转两次
              this.rotateImg(img, 'right', canvas);
              break;
          }
        }
        //进行最小压缩
        let ndata = canvas.toDataURL('image/jpeg', 0.1);
        tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0;
        return ndata;
      },
      rotateImg(img, direction, canvas) {
        //最小与最大旋转方向，图片旋转4次后回到原方向
        const min_step = 0;
        const max_step = 3;
        if (img == null) return;
        //img的高度和宽度不能在img元素隐藏后获取，否则会出错
        let height = img.height;
        let width = img.width;
        let step = 2;
        if (step == null) {
          step = min_step;
        }
        if (direction == 'right') {
          step++;
          //旋转到原位置，即超过最大值
          step > max_step && (step = min_step);
        } else {
          step--;
          step < min_step && (step = max_step);
        }
        //旋转角度以弧度值为参数
        let degree = step * 90 * Math.PI / 180;
        let ctx = canvas.getContext('2d');
        switch (step) {
          case 0:
            canvas.width = width;
            canvas.height = height;
            ctx.drawImage(img, 0, 0);
            break;
          case 1:
            canvas.width = height;
            canvas.height = width;
            ctx.rotate(degree);
            ctx.drawImage(img, 0, -height);
            break;
          case 2:
            canvas.width = width;
            canvas.height = height;
            ctx.rotate(degree);
            ctx.drawImage(img, -width, -height);
            break;
          case 3:
            canvas.width = height;
            canvas.height = width;
            ctx.rotate(degree);
            ctx.drawImage(img, -width, 0);
            break;
        }
      },




      submitData() {
        if(this.currObj.name == ''||this.currObj.name.length===0) {
          Toast('请填写姓名')
          this.$refs.nameInput.focus();
          return
        }
        if(this.currObj.phone == '') {
          Toast('请填写电话号码')
          this.$refs.phoneInput.focus();
          return
        }

        const reg = /^1[3|4|5|7|8|9][0-9]\d{8}$/;
        if(!reg.test(this.currObj.phone)) {
          Toast('电话号码格式错误')
          this.$refs.phoneInput.focus();
          return
        }
        let length=this.currObj.title.length;
        if(this.currObj.title == '') {
          Toast('请填写标题')
          this.$refs.titleInput.focus();
          return
        }

        if(this.currObj.distName == '') {
          Toast('请填写校区')
          return
        }
        if(!(length>=3&&length<=25)) {
          Toast('标题要在3到25个字之间')
          this.$refs.titleInput.focus();
          return
        }

        //通过判断下拉框的值是否是数字来判断是否有选择服务项目
        if (!(isNumber(this.currObj.serviceitemType) && isNumber(this.currObj.serviceitemId))){
          Toast('请选择好服务项目')
          return
        }
       //判断是否是 正整数
        function isNumber(val){
          var regPos = /^[0-9]*[1-9][0-9]*$/; //正整数
          if(regPos.test(val) ){
            return true;
          }else{
            return false;
          }
        }
        if(this.currObj.content == '') {
          Toast('请填写内容:')
          return
        }


        //请求接口
        //没有上传图片情况
       if(this.headerImage === ''){
          this.isDisable = true  ///执行请求后就不能点击了
          addTiezi(localStorage.getItem("userId"),this.currObj.name,this.currObj.phone,
            this.currObj.tieziType,localStorage.getItem("usertype"),localStorage.getItem("identity"),this.currObj.serviceitemType,
            this.currObj.serviceitemId,this.currObj.title,this.currObj.distName,this.currObj.content,this.currObj.classNameOrDeparment,"").then(res=>{
            if(res.status === OK) {
              if(res.data.success==true){
                this.$toast({
                  message: '发帖成功',
                  duration: 500
                })
                this.$router.push({
                  path: '/myTZ'
                })
                this.isDisable = false;//开始可以点击

              }else{
                this.isDisable = false;//开始可以点击
                Toast('发帖失败！')
              }
            }
          }).catch(error=>{
            this.isDisable = false;//开始可以点击
            console.log("错误"+error);
          })
        }else{
          this.isDisable = true  ///执行请求后就不能点击了
          addTiezi(localStorage.getItem("userId"),this.currObj.name,this.currObj.phone,
            this.currObj.tieziType,localStorage.getItem("usertype"),localStorage.getItem("identity"),this.currObj.serviceitemType,
            this.currObj.serviceitemId,this.currObj.title,this.currObj.distName,this.currObj.content,this.currObj.classNameOrDeparment,this.headerImage).then(res=>{
            if(res.status === OK) {
              if(res.data.success==true){
                this.$toast({
                  message: '发帖成功',
                  duration: 500
                })
                this.$router.push({
                  path: '/myTZ'
                })
                this.isDisable = false;//开始可以点击

              }else{
                this.isDisable = false;//开始可以点击
                Toast('发帖失败！')
              }
            }
          }).catch(error=>{
            this.isDisable = false;//开始可以点击
            console.log("错误"+error);
          })
        }

      }

    },



  }
</script>

<style type="scss" scoped>
  .tieZi{

  }
  .form-group{
    padding-top: 15px;
    padding-bottom: 15px;
  }
  .emClass{
    color: red;
    padding-right: 6px
  }
  .labelClass{

    font-size: 15px;
    padding-left: 15px

  }

  input{
    background:none;
    outline:none;
    border:0.1px;
    font-size: 16px;

  }
  select{
    height: 35px;
    width: 30%;
    background:none;
    outline:none;
    border:0px;
  }
  .sizeStyle{
    font-weight:bold;
    color:red
  }
</style>






// WEBPACK FOOTER //
// src/components/tieZi.vue